<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const teamName = computed(() => route.params.teamName)

const players = [
  'Martin Dorbek',
  'Severi Kaukiainen',
  'Kasper Suurorg',
  'Tanel Kurbas',
  'Leemet Böckler',
  'Hugo Toom',
  'Kregor Hermet',
  'Gregor Kuuba',
  'Anrijs Miska',
  'Patrick Tapé',
  'Stefan Vaaks'
]
</script>

<template>
  <div class="p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div>
        <h1 class="text-2xl font-bold">Generate roster for</h1>
        <p class="text-gray-500">{{ teamName }}</p>
      </div>
      <button class="text-blue-500 hover:text-blue-600">
        Test Fixture
      </button>
    </div>

    <!-- Search -->
    <div class="mb-6">
      <input 
        type="text" 
        placeholder="Search player"
        class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-pink-500"
      >
    </div>

    <!-- Players Table -->
    <div class="bg-white rounded-lg shadow">
      <table class="w-full">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="py-3 px-4 text-left w-16">#</th>
            <th class="py-3 px-4 text-left">Name</th>
            <th class="py-3 px-4 text-right w-24">Settings</th>
          </tr>
        </thead>
        <tbody class="divide-y">
          <tr v-for="(player, index) in players" :key="player" class="hover:bg-gray-50">
            <td class="py-3 px-4">{{ index + 1 }}</td>
            <td class="py-3 px-4 flex items-center">
              <i class="fas fa-basketball-ball mr-2 text-gray-400"></i>
              {{ player }}
            </td>
            <td class="py-3 px-4">
              <div class="flex justify-end gap-2">
                <button class="text-gray-400 hover:text-gray-600">
                  <i class="fas fa-trash"></i>
                </button>
                <button class="text-gray-400 hover:text-gray-600">
                  <i class="fas fa-cog"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template> 